"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.9999 3.64583C20.7765 3.64583 16.6479 4.89823 13.1362 7.24466C9.62452 9.59108 6.8875 12.9261 5.27125 16.8281C3.655 20.7301 3.23212 25.0237 4.05608 29.166C4.88003 33.3083 6.91382 37.1132 9.90025 40.0997C12.8867 43.0861 16.6916 45.1199 20.8339 45.9439C24.9762 46.7678 29.2699 46.3449 33.1718 44.7287C37.0738 43.1124 40.4088 40.3754 42.7553 36.8637C45.1017 33.3521 46.3541 29.2235 46.3541 25C46.3486 19.3382 44.097 13.9099 40.0935 9.90641C36.09 5.90292 30.6617 3.65134 24.9999 3.64583ZM43.2291 25C43.2279 29.2937 41.7077 33.4486 38.9374 36.7292L13.2708 11.0625C15.9243 8.821 19.1635 7.38526 22.6064 6.92467C26.0492 6.46408 29.552 6.99787 32.7013 8.46305C35.8507 9.92824 38.5153 12.2637 40.3807 15.1938C42.2461 18.1239 43.2344 21.5265 43.2291 25ZM6.77076 25C6.77195 20.7063 8.2922 16.5514 11.0624 13.2708L36.7291 38.9375C34.0756 41.179 30.8363 42.6147 27.3935 43.0753C23.9507 43.5359 20.4479 43.0021 17.2985 41.5369C14.1492 40.0718 11.4846 37.7363 9.61919 34.8062C7.75381 31.8761 6.76546 28.4735 6.77076 25Z",
    fill: fill
  }));
};

exports["default"] = _default;